// League strength order (Ben, 2026-10-26): men's and women's leagues, strongest first, comparable
// across countries — which our own HOPS can't be (it's scored within each league). A league not
// listed (e.g. Denmark's 1st Division, youth leagues) has no rank and goes after the listed ones.
// Hand-kept: edit it here. Each entry matches the DB's own name (any of `names`, ignoring case,
// accents and a " (Country)" suffix the picker adds to shared names), its country and gender.
// Checked against the DB's 276 leagues on 2026-10-26: every listed league the DB has matches; the
// rest aren't in the DB.

export interface StrengthLeague {
  womens: boolean;
  country: string;
  names: readonly string[];
}

export const LEAGUE_STRENGTH: readonly StrengthLeague[] = [
  // Men's
  { womens: false, country: "England", names: ["Premier League"] }, // 1
  { womens: false, country: "Germany", names: ["Bundesliga", "1. Bundesliga"] }, // 2
  { womens: false, country: "Spain", names: ["LaLiga", "La Liga", "Primera División", "Primera Division"] }, // 3
  { womens: false, country: "Italy", names: ["Serie A"] }, // 4
  { womens: false, country: "France", names: ["Ligue 1"] }, // 5
  { womens: false, country: "Brazil", names: ["Serie A", "Série A", "Brasileirão", "Brasileirao"] }, // 6
  { womens: false, country: "Belgium", names: ["Pro League", "Jupiler Pro League", "First Division A"] }, // 7
  { womens: false, country: "Portugal", names: ["Liga Portugal", "Primeira Liga", "Liga NOS"] }, // 8
  { womens: false, country: "Argentina", names: ["Liga Profesional", "Primera División", "Primera Division", "Liga Profesional Argentina"] }, // 9
  { womens: false, country: "England", names: ["Championship"] }, // 10
  { womens: false, country: "Netherlands", names: ["Eredivisie"] }, // 11
  { womens: false, country: "Norway", names: ["Eliteserien"] }, // 12
  { womens: false, country: "Mexico", names: ["Liga MX"] }, // 13
  { womens: false, country: "USA", names: ["MLS", "Major League Soccer"] }, // 14
  { womens: false, country: "Colombia", names: ["Primera A", "Liga BetPlay", "Primera División", "Primera Division"] }, // 15
  { womens: false, country: "Poland", names: ["Ekstraklasa"] }, // 16
  { womens: false, country: "Ecuador", names: ["Serie A", "Liga Pro", "LigaPro Serie A"] }, // 17
  { womens: false, country: "Czechia", names: ["1. Liga", "Czech Liga", "Fortuna Liga", "Chance Liga", "First League"] }, // 18
  { womens: false, country: "Turkiye", names: ["Super Lig", "Süper Lig"] }, // 19
  { womens: false, country: "Switzerland", names: ["Super League"] }, // 20
  { womens: false, country: "Denmark", names: ["Superliga"] }, // 21
  { womens: false, country: "Austria", names: ["Bundesliga"] }, // 22
  { womens: false, country: "Russia", names: ["Premier League", "Premier Liga"] }, // 23
  { womens: false, country: "Croatia", names: ["HNL", "1. HNL", "Prva HNL", "SuperSport HNL"] }, // 24
  { womens: false, country: "Chile", names: ["Primera Division", "Primera División"] }, // 25
  { womens: false, country: "Spain", names: ["LaLiga 2", "La Liga 2", "LaLiga2", "Segunda División", "Segunda Division"] }, // 26
  { womens: false, country: "Germany", names: ["2. Bundesliga"] }, // 27
  { womens: false, country: "Paraguay", names: ["Division Profesional", "División Profesional", "Primera División", "Primera Division"] }, // 28
  { womens: false, country: "Greece", names: ["Super League 1", "Super League"] }, // 29
  { womens: false, country: "Uruguay", names: ["Primera Division", "Primera División"] }, // 30
  { womens: false, country: "Cyprus", names: ["1. Division", "First Division"] }, // 31
  { womens: false, country: "Japan", names: ["J. League", "J1 League", "J League", "J-League"] }, // 32
  { womens: false, country: "Sweden", names: ["Allsvenskan"] }, // 33
  { womens: false, country: "Hungary", names: ["NB I", "NB 1", "OTP Bank Liga"] }, // 34
  { womens: false, country: "Scotland", names: ["Premiership", "Scottish Premiership"] }, // 35
  { womens: false, country: "Saudi Arabia", names: ["Pro League", "Saudi Pro League"] }, // 36
  { womens: false, country: "France", names: ["Ligue 2"] }, // 37
  { womens: false, country: "Morocco", names: ["Botola Pro"] }, // 38
  { womens: false, country: "Peru", names: ["Primera Division", "Primera División", "Liga 1"] }, // 39
  { womens: false, country: "Israel", names: ["Ligat HaAl", "Ligat ha'Al", "Premier League"] }, // 40
  { womens: false, country: "South Korea", names: ["K League 1", "K-League 1", "K League"] }, // 41
  { womens: false, country: "Italy", names: ["Serie B"] }, // 42
  { womens: false, country: "Egypt", names: ["Premier League"] }, // 43
  { womens: false, country: "Romania", names: ["SuperLiga", "Liga I", "Liga 1"] }, // 44
  { womens: false, country: "Bolivia", names: ["Primera Division", "Primera División", "LFPB"] }, // 45
  { womens: false, country: "England", names: ["League One"] }, // 46
  { womens: false, country: "Venezuela", names: ["Primera Division", "Primera División"] }, // 47
  { womens: false, country: "Azerbaijan", names: ["Premier League"] }, // 48
  { womens: false, country: "Costa Rica", names: ["Primera Division", "Primera División"] }, // 49
  { womens: false, country: "Algeria", names: ["Ligue 1"] }, // 50
  { womens: false, country: "Bulgaria", names: ["First Professional League", "Parva Liga", "First League"] }, // 51
  { womens: false, country: "Ukraine", names: ["Premier League", "Premier Liha"] }, // 52
  { womens: false, country: "Slovakia", names: ["1. Liga", "Super Liga", "Niké liga", "Nike liga"] }, // 53
  { womens: false, country: "Portugal", names: ["Liga Portugal 2", "Segunda Liga", "LigaPro"] }, // 54
  { womens: false, country: "Serbia", names: ["Super Liga", "SuperLiga"] }, // 55
  { womens: false, country: "Slovenia", names: ["Prva Liga", "PrvaLiga", "1. SNL"] }, // 56
  { womens: false, country: "Chile", names: ["Primera B"] }, // 57
  { womens: false, country: "Honduras", names: ["Liga Nacional"] }, // 58
  { womens: false, country: "Iran", names: ["Persian Gulf Pro League", "Pro League"] }, // 59
  { womens: false, country: "South Africa", names: ["PSL", "Premiership", "Premier Soccer League"] }, // 60
  { womens: false, country: "UAE", names: ["Pro League", "UAE Pro League", "Arabian Gulf League"] }, // 61
  { womens: false, country: "Bosnia-Herzegovina", names: ["Premier League"] }, // 62
  { womens: false, country: "Finland", names: ["Veikkausliiga"] }, // 63
  { womens: false, country: "Australia", names: ["A-League", "A-League Men"] }, // 64
  { womens: false, country: "Colombia", names: ["Primera B", "Torneo BetPlay"] }, // 65
  { womens: false, country: "Ecuador", names: ["Liga Pro Serie B", "Serie B"] }, // 66
  { womens: false, country: "Brazil", names: ["Serie B", "Série B"] }, // 67
  { womens: false, country: "Switzerland", names: ["Challenge League"] }, // 68
  { womens: false, country: "Belgium", names: ["Challenger Pro League"] }, // 69
  { womens: false, country: "Qatar", names: ["Qatar Stars League", "Stars League"] }, // 70
  { womens: false, country: "Georgia", names: ["Erovnuli Liga"] }, // 71
  { womens: false, country: "Russia", names: ["First League"] }, // 72
  { womens: false, country: "Tunisia", names: ["Ligue 1"] }, // 73
  { womens: false, country: "Paraguay", names: ["Division Intermedia"] }, // 74
  { womens: false, country: "England", names: ["League Two"] }, // 75
  { womens: false, country: "Czechia", names: ["FNL", "Chance National Liga", "National League", "2. Liga"] }, // 76
  { womens: false, country: "Latvia", names: ["Virsliga"] }, // 77
  { womens: false, country: "China", names: ["CSL", "Super League", "Chinese Super League"] }, // 78
  { womens: false, country: "Portugal", names: ["Liga 3"] }, // 79
  { womens: false, country: "Peru", names: ["Segunda División", "Segunda Division", "Liga 2"] }, // 80
  { womens: false, country: "Netherlands", names: ["Eerste Divisie"] }, // 81
  { womens: false, country: "USA", names: ["USL Championship"] }, // 82
  { womens: false, country: "Austria", names: ["2. Liga"] }, // 83
  { womens: false, country: "Uruguay", names: ["Segunda División", "Segunda Division"] }, // 84
  { womens: false, country: "South Korea", names: ["K League 2", "K-League 2"] }, // 85
  { womens: false, country: "Israel", names: ["Liga Leumit"] }, // 86
  { womens: false, country: "Canada", names: ["Premier League", "Canadian Premier League"] }, // 87
  { womens: false, country: "Venezuela", names: ["Segunda División", "Segunda Division"] }, // 88
  { womens: false, country: "Scotland", names: ["Championship"] }, // 89
  { womens: false, country: "Saudi Arabia", names: ["Division 1"] }, // 90
  { womens: false, country: "Romania", names: ["Liga II"] }, // 91
  { womens: false, country: "Serbia", names: ["Prva Liga"] }, // 92
  { womens: false, country: "India", names: ["Super League", "Indian Super League"] }, // 93
  { womens: false, country: "Qatar", names: ["Second Division"] }, // 94
  { womens: false, country: "Cyprus", names: ["2. Division"] }, // 95
  { womens: false, country: "Belgium", names: ["First Amateur Division"] }, // 96
  { womens: false, country: "Finland", names: ["Ykkösliiga", "Ykkosliiga"] }, // 97
  { womens: false, country: "England", names: ["National League"] }, // 98
  { womens: false, country: "Slovenia", names: ["2. SNL", "Druga Liga"] }, // 99
  { womens: false, country: "Ukraine", names: ["Persha Liga", "First League"] }, // 100
  { womens: false, country: "Bosnia-Herzegovina", names: ["1st League - FBiH"] }, // 101
  { womens: false, country: "Georgia", names: ["Erovnuli Liga 2"] }, // 102
  { womens: false, country: "Scotland", names: ["League One"] }, // 103
  { womens: false, country: "Bosnia-Herzegovina", names: ["1st League - RS"] }, // 104
  { womens: false, country: "UAE", names: ["Division 1"] }, // 105
  { womens: false, country: "Latvia", names: ["1. Liga"] }, // 106
  // Added 2026-10-26 (Ben): leagues in our data the list above lacks, after every listed one, in
  // the order of their country's top league.
  { womens: false, country: "Germany", names: ["3. Liga"] },
  { womens: false, country: "Italy", names: ["Serie C"] },
  { womens: false, country: "Argentina", names: ["Primera Nacional"] },
  { womens: false, country: "Norway", names: ["OBOS-ligaen"] },
  { womens: false, country: "Japan", names: ["J2 League", "J2"] },
  { womens: false, country: "Sweden", names: ["Superettan"] },
  { womens: false, country: "Iceland", names: ["Besta deild karla"] },
  // Women's
  { womens: true, country: "USA", names: ["NWSL", "National Women's Soccer League"] }, // 1
  { womens: true, country: "England", names: ["WSL", "FA WSL", "FAWSL", "FA Women's Super League", "Women's Super League"] }, // 2
  { womens: true, country: "Spain", names: ["Liga F", "Primera División Femenina", "Primera Division Femenina"] }, // 3
  { womens: true, country: "France", names: ["Première Ligue", "Premiere Ligue", "D1 Arkema", "Division 1 Féminine", "Division 1 Feminine"] }, // 4
  { womens: true, country: "Italy", names: ["Serie A Women", "Serie A Femminile", "Women's Serie A"] }, // 5
  { womens: true, country: "Germany", names: ["Frauen Bundesliga", "Frauen-Bundesliga", "Women's Bundesliga"] }, // 6
  { womens: true, country: "Sweden", names: ["Damallsvenskan"] }, // 7
  { womens: true, country: "Portugal", names: ["1a Divisão Women", "Campeonato Nacional Feminino", "Liga BPI"] }, // 8
  { womens: true, country: "England", names: ["WSL 2", "Barclays Women's Super League 2", "FA Women's Championship", "Women's Championship", "Championship"] }, // 9
  { womens: true, country: "Brazil", names: ["Brasileiro Women", "Brasileiro Feminino"] }, // 10
  { womens: true, country: "Norway", names: ["Toppserien"] }, // 11
  { womens: true, country: "Mexico", names: ["Liga MX Femenil"] }, // 12
  { womens: true, country: "Japan", names: ["WE League"] }, // 13
  { womens: true, country: "Spain", names: ["Primera Federación"] }, // 14
  { womens: true, country: "Australia", names: ["A-League Women"] }, // 15
  { womens: true, country: "Netherlands", names: ["Eredivisie Women", "Eredivisie Vrouwen"] }, // 16
  { womens: true, country: "Denmark", names: ["Elitedivisionen", "Kvindeliga", "Kvindeligaen"] }, // 17
  { womens: true, country: "Finland", names: ["Kansallinen Liiga"] }, // 18
  { womens: true, country: "South Korea", names: ["WK League"] }, // 19
  { womens: true, country: "Switzerland", names: ["Women's Super League"] }, // 20
  { womens: true, country: "USA", names: ["USL Super League"] }, // 21
  { womens: true, country: "Iceland", names: ["Úrvalsdeild Women", "Úrvalsdeild", "Besta deild"] }, // 22
  { womens: true, country: "Turkiye", names: ["Super Ligi", "Süper Ligi", "Women's Super League"] }, // 23
  { womens: true, country: "Hungary", names: ["Noi NB 1"] }, // 24
  { womens: true, country: "Germany", names: ["2. Frauen Bundesliga", "2. Frauen-Bundesliga"] }, // 25
  { womens: true, country: "Scotland", names: ["SWPL 1", "SWPL", "Scottish Women's Premier League"] }, // 26
  { womens: true, country: "France", names: ["Seconde Ligue", "D2 Féminine", "Division 2 Féminine"] }, // 27
  { womens: true, country: "Belgium", names: ["Super League"] }, // 28
  { womens: true, country: "Poland", names: ["Ekstraliga Women"] }, // 29
  { womens: true, country: "Russia", names: ["Russian Super League"] }, // 30
  { womens: true, country: "Sweden", names: ["Elitettan"] }, // 31
  { womens: true, country: "Italy", names: ["Serie B Women"] }, // 32
  { womens: true, country: "Czechia", names: ["1. Liga Women"] }, // 33
  { womens: true, country: "Austria", names: ["OFB Frauen Bundesliga", "ÖFB Frauen Bundesliga", "Frauen Bundesliga"] }, // 34
];

const fold = (s: string) =>
  s
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[‘’]/g, "'")
    .replace(/\s*\([^)]*\)\s*$/, "")
    .trim()
    .toLowerCase();

// The site's country names → the other names the DB may use for the same country.
const COUNTRY_ALIASES: Readonly<Record<string, readonly string[]>> = {
  usa: ["united states of america", "united states"],
  netherlands: ["netherlands, kingdom of the"],
  bolivia: ["bolivia, plurinational state of"],
  venezuela: ["venezuela, bolivarian republic of"],
  czechia: ["czech republic"],
  turkiye: ["turkey"],
  "south korea": ["korea republic", "korea, republic of", "republic of korea"],
  uae: ["united arab emirates"],
  "bosnia-herzegovina": ["bosnia and herzegovina"],
  russia: ["russian federation"],
  iran: ["ir iran", "iran, islamic republic of"],
};
const sameCountry = (db: string, listed: string) => {
  const a = fold(db);
  const b = fold(listed);
  return a === b || (COUNTRY_ALIASES[b] ?? []).includes(a);
};

/**
 * Where a league sits in the strength order for its own gender (0 = strongest), or null when it
 * isn't listed (or its gender / country isn't known). Pure.
 */
export function leagueStrengthRank(league: { name: string; countryName: string | null; womens: boolean | null }): number | null {
  const { countryName, womens } = league;
  if (womens === null || countryName === null) return null;
  const name = fold(league.name);
  const own = LEAGUE_STRENGTH.filter((l) => l.womens === womens);
  const i = own.findIndex((l) => sameCountry(countryName, l.country) && l.names.some((n) => fold(n) === name));
  return i === -1 ? null : i;
}
